import { useParams } from 'react-router';
import { LinkUnavailablePage } from './LinkUnavailablePage';
import { RedirectToServiceRequest } from './RedirectToServiceRequest';

export function OldAppointmentManageRedirect() {
  const { token } = useParams<{ token: string }>();
  if (!token) {
    return <LinkUnavailablePage />;
  }
  return <RedirectToServiceRequest kind="appointment" token={token} />;
}
